import { Suspense } from "react";
import { AllHireTalentRoutes } from ".";
import Loader from "../../components/loader";
import { Routes, Route } from "react-router-dom";

const HireTalentRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {AllHireTalentRoutes?.map((item, index) => {
          return (
            <Route key={index} exact path={item.path} element={item?.element} />
          );
        })}

        {/* <Route exact path="*" element={<PageNotFound />} /> */}
      </Routes>
    </Suspense>
  );
};

export default HireTalentRoutes;
